export default {"src":"/_next/static/media/wired-logo.90b758c6.svg","height":25,"width":125,"blurWidth":0,"blurHeight":0};